import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import { locusFetchList } from 'reducers/locus/reducer'
import Psfs from 'lib/psfs/Psfs'
import messages from './translate'

class DependentSelectLists extends Component {
  componentDidMount() {
    const { siteValue } = this.props

    this.fetchLocusList(siteValue)
  }

  shouldComponentUpdate(nextProps) {
    const { siteValue } = this.props
    const { setLocuses, siteValue: nextSiteValue } = nextProps

    if (siteValue !== nextSiteValue) {
      this.fetchLocusList(nextSiteValue)
      setLocuses([])

      return false
    }

    return true
  }

  fetchLocusList = siteValue => {
    const { locusFetchList } = this.props

    if (siteValue) {
      const psfs = new Psfs()
      psfs.addFilter('site', siteValue)
      locusFetchList({ psfs })
    }
  }

  onSiteListChange = ({ target: { value } }) => {
    const { setSite } = this.props

    setSite(value)
  }

  onLocusListChange = ({ target: { value } }) => {
    const { setLocuses } = this.props

    setLocuses(value)
  }

  render() {
    const {
      siteList,
      locusList,
      siteValue,
      siteError,
      locusesValue,
      locusesError,
      intl: { formatMessage },
    } = this.props
    const locusListUnpack = locusList.toArray()

    return (
      <>
        <FormControl
          fullWidth
          component="div"
          className="form-group"
          error={Boolean(siteError)}>
          <InputLabel required>{formatMessage(messages.site)}</InputLabel>
          <Select
            autoWidth
            value={siteValue}
            onChange={this.onSiteListChange}
            MenuProps={{ getContentAnchorEl: null }}>
            {siteList.map(({ id, name }) => (
              <MenuItem button key={id} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
          {Boolean(siteError) && <FormHelperText>{siteError}</FormHelperText>}
        </FormControl>
        <FormControl
          fullWidth
          component="div"
          className="form-group"
          error={Boolean(locusesError)}>
          <InputLabel>{formatMessage(messages.units)}</InputLabel>
          <Select
            multiple
            value={locusesValue}
            disabled={!locusListUnpack.length}
            onChange={this.onLocusListChange}
            MenuProps={{ getContentAnchorEl: null }}>
            {locusListUnpack.map(({ id, containerName }) => (
              <MenuItem button key={id} value={id}>
                {containerName}
              </MenuItem>
            ))}
          </Select>
          {Boolean(locusesError) && (
            <FormHelperText>{locusesError}</FormHelperText>
          )}
        </FormControl>
      </>
    )
  }
}

export default connect(
  state => ({
    locusList: state.getIn(['locus', 'listData']),
  }),
  {
    locusFetchList,
  },
)(injectIntl(DependentSelectLists))
